export function resolveApiBase(envValue = process.env.REACT_APP_API_URL) {
  if (typeof envValue !== "string") return "";
  return envValue.trim().replace(/\/$/, "");
}

export function apiUrl(path, envValue) {
  const base = resolveApiBase(envValue);
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `${base}${suffix}`;
}
